// extracted by mini-css-extract-plugin
export var orderDetails = "_kv-2";
export var orderImage = "_kv-1";
export var orderMeta = "_kv-3";
export var orderSummary = "_kv-0";
export var rightArrow = "_kv-4";